// extracted by mini-css-extract-plugin
export var discard = "_41-3";
export var muiTooltipTooltip = "_41-5";
export var notificationBar = "_41-2";
export var saveButtonHoverSlotWrapper = "_41-4";
export var show = "_41-1";
export var spacer = "_41-0";